import { render, staticRenderFns } from "./public_generic_card_element.vue?vue&type=template&id=bd462db0&"
import script from "./public_generic_card_element.vue?vue&type=script&lang=js&"
export * from "./public_generic_card_element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports